module.exports = __webpack_public_path__ + "img/brazil.23a2670c.svg";